// extracted by mini-css-extract-plugin
module.exports = {"user":"UserMenu_user__V_AI5","icon":"UserMenu_icon__45MWr","support":"UserMenu_support__W1Sw6"};